var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vuetify-ad',{attrs:{"medium":_vm.medium}})
}
var staticRenderFns = []

export { render, staticRenderFns }